import React, { useState } from "react";
import { Link } from "react-router-dom";
import newsIcon from "../../images/Icons/news.png";
import { useEffect } from "react";
import placeImage from "../../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchNews } from "../../redux/slice/news";
import Dataloader from "../../Component/Dataloader";
import NoData from "../../Component/NoData";

export default function NewsList() {
  const dispatch = useDispatch();
  const { newsData, isError } = useSelector((state) => state.news);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (!isError) {
        setLoading(true);
        try {
          await dispatch(fetchNews());
        } catch (err) {
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [dispatch, isError]);

  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="showcase-product mrb1">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Dataloader />
            </div>
          ) : (
            <>
              <div className="row-hd-txt">
                <div className="row-hd-txt-left">
                  <img src={newsIcon} alt="icon" />
                  <h5>All Market News</h5>
                </div>
              </div>
              {newsData.length > 0 ? (
                <div className="row shwc-pd-row">
                  {newsData.map((data, index) => {
                    return (
                      <div className="col-lg-3 col-md-4 col-6 px-2" key={index}>
                        <Link
                          to={`/news-detail/${data.slug}`}
                          className="shwc-pd-dt"
                        >
                          <figure>
                            <img
                              src={data.image}
                              onError={imageOnError}
                              alt="product"
                            />
                          </figure>

                          <span className="two-line-clamp">{data.title}</span>
                          <button className="news-link">
                            Continue Reading
                          </button>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <NoData />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
